//export const DEFAULT_URI = 'http://localhost:3001';
export const DEFAULT_URI = 'https://seekneakers-api.payogaputra.com';